import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsuarioService {

  apiUrl: string = environment.REST_API.URL;
  constructor(private http: HttpClient) { }

  autentica(credenciales) {
    return this.http.post(this.apiUrl + "usuario/autentica", credenciales);
  }

  verificaCodigo(credenciales) {
    return this.http.post(this.apiUrl + "usuario/verificaCodigo", credenciales);
  }

  actualizaContrasena(credenciales) {
    return this.http.post(this.apiUrl + "usuario/actualizaContrasena", credenciales);
  }

  recuperarContrasena(correoElectronico) {
    return this.http.get(this.apiUrl + "usuario/recuperarContrasena?correoElectronico=" + correoElectronico);
  }

  guardar(usuario) {
    return this.http.post(this.apiUrl + "usuario/agregarUsuario", usuario);
  }

  actualizar(usuario) {
    return this.http.put(this.apiUrl + "usuario/actualizarUsuario", usuario);
  }

  eliminarPorId(idUsuario: number) {
    return this.http.delete(this.apiUrl + "usuario/eliminarUsuario?idUsuario=" + idUsuario);
  }

  obtenerPagina(page: number, size: number) {
    return this.http.get(this.apiUrl + "usuario/obtenerUsuarios?page=" + page + "&size=" + size);
  }

  obtenerPaginaLink(link) {
    return this.http.get(link);
  }

}
